<template>
	<div class="dashboard-widget dashboard-widget-watches">
		<div class="header">
			<svgicon name="watch" :fill="false"></svgicon>
			<h2>{{ $t('base.general.patients') }}</h2>
		</div>
		<div class="body">
			<div v-if="watches.length" class="watches-container">
					<div class="swiper-container swiper-container-watches">
						<div class="swiper-wrapper">
							<watches-widget-watch v-for="watch in watches" :key="watch.id" :user_uid="user_uid" :watch="watch" class="swiper-slide"/>
							<router-link v-if="matches" :to="{ name: 'WatchList', params: { user_uid: user_uid } }" class="swiper-slide see-all">
								<svgicon name="watch" :fill="false"></svgicon>
								<span>{{ $t('base.general.see_all_patients') }}</span>
							</router-link>
						</div>
						<div class="swiper-pagination"></div>
					</div>
					<router-link v-if="!matches" :to="{ name: 'WatchList', params: { user_uid: user_uid } }" class="see-all">
						<svgicon name="watch" :fill="false"></svgicon>
						<span>{{ $t('base.general.see_all_patients') }}</span>
					</router-link>
			</div>
			<div v-else>
				<p>{{ $t('base.general.no_patients') }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import { Swiper, Pagination, Mousewheel } from 'swiper/dist/js/swiper.esm.js'
import WatchesWidgetWatch from './components/WatchesWidgetWatch'
Swiper.use([ Pagination, Mousewheel ]);
export default {
	components: {
		WatchesWidgetWatch
	},
	props: [
		'user_uid',
		'watches'
	],
	data () {
		return {
			swiper: null,
			breakpoint: null,
			matches: null
		}
	},
	watch: {
		watches: {
			handler () {
				this.$nextTick(function () {
					this.swiper = new Swiper('.swiper-container-watches', {
						observer: true,
						slidesPerView: 3,
						spaceBetween: 10,
						mousewheel: true,
						breakpoints: {
							1025: {
								slidesPerView: 1,
								spaceBetween: 10
							},
							1275: {
								slidesPerView: 2,
								spaceBetween: 10
							}
						},
						pagination: {
							el: '.swiper-pagination',
							type: 'bullets',
							clickable: true,
						}
					})
					
					this.breakpoint = window.matchMedia('(max-width: 1025px)')
					this.matches = this.breakpoint.matches
					this.breakpoint.addListener(this.breakpointChecker)
				})
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		breakpointChecker () {
			if (this.breakpoint.matches === true) {
				this.matches = true
			} else if (this.breakpoint.matches === false) {
				this.matches = false
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/WatchesWidget.vue